// extracted by mini-css-extract-plugin
export var legendIndicator = "_az-1";
export var legendRight = "_az-0";